import React from "react";
import { Box, Button, Heading, Layer, Paragraph, ResponsiveContext } from "grommet";
import { IconSvg } from "../../IconSvg";
export var AnswerPopup = function AnswerPopup(_ref) {
  var paragraph = _ref.paragraph,
    heading = _ref.heading,
    closePopup = _ref.closePopup;
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Layer,
        {
          onClickOutside: closePopup,
          onEsc: closePopup,
          full: true,
          background: "transparent",
          animation: "fadeIn",
          position: "center",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            fill: true,
            background: "rgba(196, 196, 196, 1)",
            align: "center",
            justify: "center",
            style: {
              position: "relative",
              visibility: "visible",
            },
            overflow: "auto",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              width: "694px",
              background: {
                color: "site-colors-1",
              },
              round: "20px",
              style: {
                position: "absolute",
              },
              pad: "20px 40px 56px 40px",
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                width: "22px",
                alignSelf: "end",
              },
              /*#__PURE__*/ React.createElement(Button, {
                icon: /*#__PURE__*/ React.createElement(IconSvg, {
                  src: "darkClose",
                }),
                onClick: closePopup,
                alignSelf: "center",
              })
            ),
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "0.75rem",
                fill: true,
                color: "black",
                style: {
                  paddingBottom: "16px",
                },
              },
              paragraph
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              {
                gap: "large",
              },
              /*#__PURE__*/ React.createElement(
                Heading,
                {
                  level: 4,
                  color: "black",
                },
                heading
              ),
              /*#__PURE__*/ React.createElement(
                Paragraph,
                {
                  size: "1rem",
                  style: {
                    lineHeight: "24px",
                  },
                  color: "black",
                },
                paragraph
              )
            )
          )
        )
      );
    })
  );
};
